"use client";

import { Icon } from "@ospweb/sdk-ui";
import { MenuModal } from "@components/Menu/MenuModal";
import { PLAN_DASHBOARD_DEMO_COPY } from "@screens/plan/constants/planDashboardMockContent";
import { PLAN_DASHBOARD_LAYOUT } from "@screens/plan/constants/planDashboardTokens";
import { cn } from "utils";
import { useMainTabHeaderLogic } from "@/src/hooks/useMainTabHeaderLogic";
import { HeaderScoreChip } from "./HeaderScoreChip";

// const I18n = I18nUtil.createScoped(Translations);

const iconCircleClass =
  "inline-flex size-10 shrink-0 items-center justify-center rounded-full bg-background_solid_neutral_primary shadow-[0px_0px_32px_0px_rgba(0,0,0,0.08)]";

/** Figma `94100:118551` — 8px dot on 40px header icon button */
const defaultHeaderRowClass =
  "sticky top-0 z-10 flex w-full items-center gap-3 px-4 pb-3 pt-2 bg-background_solid_secondary";

export type MainTabHeaderProps = {
  className?: string;
  trackingModuleName: string;
  /** 主 Tab 顶栏变体；默认 `plan`，右侧用户按钮统一跳转 `/goal` */
  variant?: "default" | "tracker" | "plan";
  /** Paid Dashboard H5 — Figma `91919:52155` Demo 标签 + close 整合进顶栏 */
  planDashboardDemo?: boolean;
};

export const MainTabHeader = ({
  className,
  trackingModuleName,
  planDashboardDemo = false,
}: MainTabHeaderProps) => {
  const { labelConfig, isMenuOpen, openMenu, closeMenu, commonClickHandler } =
    useMainTabHeaderLogic(trackingModuleName);

  return (
    <>
      <div
        className={cn(defaultHeaderRowClass, className)}
        data-testid="main-tab-header"
      >
        {planDashboardDemo ? (
          <button
            type="button"
            data-testid="plan-dashboard-demo-close"
            aria-label="Close demo banner"
            className={iconCircleClass}
            onClick={() => {}}
          >
            <Icon name="close" size={20} className="text-content_primary" />
          </button>
        ) : (
          <button
            type="button"
            data-openreplay-label="misc_maintab_menubutton"
            data-tracking-eventname="nav_hamburger_click"
            className={iconCircleClass}
            onClick={openMenu}
            aria-label="Menu"
          >
            <Icon name="menu" size={20} className="text-content_primary" />
          </button>
        )}

        <div className="flex min-w-0 flex-1 items-center">
          {planDashboardDemo ? (
            <div
              data-testid="plan-dashboard-demo-banner"
              className="flex min-w-0 flex-1 items-center"
            >
              <h2 className={PLAN_DASHBOARD_LAYOUT.demoTitleClass}>
                {PLAN_DASHBOARD_DEMO_COPY.demoTitle}
              </h2>
            </div>
          ) : labelConfig ? (
            <button
              type="button"
              data-openreplay-label="misc_maintab_memberstatusbutton"
              data-tracking-eventname="nav_upgrade_click"
              className={cn(
                "flex shrink-0 items-center gap-[2px] rounded-[46px] px-2 py-[5px] body_bold_m",
                labelConfig.className,
              )}
              onClick={() => commonClickHandler(labelConfig.onClick)}
              aria-label={labelConfig.text}
            >
              <Icon name="aura" size={16} />
              {labelConfig.text}
            </button>
          ) : null}
        </div>

        <HeaderScoreChip />
      </div>
      <MenuModal isOpen={isMenuOpen} onCancel={closeMenu} placement="left" />
    </>
  );
};
